export const getFooterQuery = (lang = 'en') => `
{
  findFooterSingleton {
    data {
      text {
        ${lang}{
          textContent
        }
      }
    }
  }
}
  
`;